var _path, _mask, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _circle8, _circle9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSadNacho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 52 56",
    width: 52,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AFD4FF",
    d: "M50.3351 48.414C50.2443 51.5302 46.7817 53.3493 44.1642 51.6561L13.5269 31.837C11.0149 30.212 11.1107 26.5053 13.7032 25.0122L45.4507 6.72783C48.1624 5.16607 51.5365 7.18259 51.4453 10.3106L50.3351 48.414Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 41,
    height: 47,
    x: 11,
    y: 6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AFD4FF",
    d: "M50.2019 48.4097C50.102 51.5256 46.634 53.3346 44.0215 51.6336L13.4426 31.7246C10.9354 30.0922 11.042 26.3859 13.639 24.9004L45.4401 6.70936C48.1563 5.15558 51.5244 7.182 51.4241 10.3097L50.2019 48.4097Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern0)",
    d: "M0 0H36.5279V59.2465H0z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "matrix(-0.946724 0.322047 0.322047 0.946724 57.3403 -3.30127)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#181351",
    strokeLinecap: "round",
    strokeWidth: 2.70812,
    d: "M42.5948 35.7026C41.2031 34.3261 39.4613 33.6347 37.7432 33.9713C36.0251 34.308 34.673 35.6056 33.9037 37.4054"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.91321,
    cy: 2.3021,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 4.91321 2.3021)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2882,
    cy: 7.35825,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 10.2882 7.35825)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6627,
    cy: 12.4144,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 15.6627 12.4144)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.17347,
    cy: 11.8329,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 4.17347 11.8329)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.54798,
    cy: 16.889,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 9.54798 16.889)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.43323,
    cy: 21.3636,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 3.43323 21.3636)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.69349,
    cy: 30.8949,
    r: 1.875,
    fill: "#FFCFD5",
    transform: "rotate(4.43918 2.69349 30.8949)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#70B2FF",
    d: "M19.8361 45.1889C20.5926 46.2928 21.7567 47.051 23.0722 47.2966C24.3878 47.5423 25.747 47.2552 26.8509 46.4987C27.9548 45.7422 28.713 44.5781 28.9586 43.2626C29.3795 41.0087 27.0042 35.124 26.149 33.1061C26.1168 33.0293 26.066 32.9618 26.0012 32.9095C25.9364 32.8572 25.8597 32.8218 25.7779 32.8066C25.696 32.7913 25.6117 32.7966 25.5324 32.8219C25.4531 32.8473 25.3814 32.892 25.3236 32.952C23.7959 34.5249 19.459 39.1563 19.0382 41.4102C18.7925 42.7257 19.0796 44.085 19.8361 45.1889Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.3923,
    cy: 24.7944,
    r: 2.1665,
    fill: "#181351"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0325,
    cy: 28.1777,
    r: 2.1665,
    fill: "#181351"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(0.00609756 0.0037594)",
    xlinkHref: "#image0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadNacho);
export default __webpack_public_path__ + "static/media/sad_nacho.a4f2eb9a5b0f498fdb208e89ae4744cb.svg";
export { ForwardRef as ReactComponent };